const {
	declarativeOperations: {SET, ASSIGN, MERGE}
} = operations;
import * as operations from '../operators/operations';
import getStatePropsContext from './getStatePropsContext';
import {get, isPlainObject} from '@servicenow/ui-internal';

const isEmptyStateUpdate = value => {
	return (
		// (value instanceof Map && value.size === 0) ||
		isPlainObject(value) && Object.keys(value).length === 0
	);
};

function isPrimitive(value) {
	const type = typeof value;
	if (type === 'object' || type === 'function') return false;

	if (type === 'string') return true;
	if (type === 'bigint') return true;
	if (type === 'boolean') return true;
	if (type === 'number') return true;

	return false;
}

const isPrimitiveOrNull = value => isPrimitive(value) || value === null;

export function isDeclarativeUpdate(update = {}) {
	const {operation, path, value} = update;
	return operation && (path || value);
}

export function isValidOperation(operation) {
	return operations[operation] !== undefined;
}

export function isBatch(update) {
	return Array.isArray(update) && update.every(u => isDeclarativeUpdate(u) || isUpdater(u));
}

export function isUpdater(update) {
	return typeof update === 'function';
}

export function resolveUpdate(host, hostVariables, update, interactionId) {
	if (!isUpdater(update)) return update;

	const statePropsContext = getStatePropsContext(host, interactionId);
	return update(statePropsContext) || statePropsContext;
}

export function isValidOptimisationOperation(operation) {
	return operation && [SET, ASSIGN, MERGE].includes(operation);
}

export function shouldUpdateState(currentState, update) {
	const declarativeUpdate = !!isDeclarativeUpdate(update);
	const {path = '', value, operation} = update;
	if (declarativeUpdate && operation !== SET && operation !== ASSIGN && operation !== MERGE)
		return true;

	const updateKeys = declarativeUpdate ? null : Object.keys(update);
	if (updateKeys === null || updateKeys.length === 1) {
		const currentValue = declarativeUpdate ? get(currentState, path) : currentState[updateKeys[0]];
		const nextValue = declarativeUpdate ? value : update[updateKeys[0]];
		if (
			isPrimitiveOrNull(nextValue) &&
			isPrimitiveOrNull(currentValue) &&
			nextValue === currentValue
		) {
			return false;
		}

		if (isEmptyStateUpdate(nextValue) && isEmptyStateUpdate(currentValue)) {
			return false;
		}

		if (isPlainObject(currentValue) && isPlainObject(nextValue)) {
			const nextValueKeys = Object.keys(nextValue);
			const currentValueKeys = Object.keys(currentValue);

			if (nextValueKeys.length <= 2 && nextValueKeys.length === currentValueKeys.length) {
				const currentValue1 = currentValue[nextValueKeys[0]];
				const currentValue2 = currentValue[nextValueKeys[1]];
				const nextValue1 = nextValue[nextValueKeys[0]];
				const nextValue2 = nextValue[nextValueKeys[1]];

				if (
					declarativeUpdate &&
					operation === SET &&
					(nextValueKeys[0] !== currentValueKeys[0] || nextValueKeys[1] !== currentValueKeys[1])
				)
					return true;

				if (
					isPrimitiveOrNull(nextValue1) &&
					isPrimitiveOrNull(currentValue1) &&
					nextValue1 === currentValue1 &&
					isPrimitiveOrNull(nextValue2) &&
					isPrimitiveOrNull(currentValue2) &&
					nextValue2 === currentValue2
				) {
					return false;
				}
			}
		}
	}

	return true;
}
